import { render, staticRenderFns } from "./SingleSelectQuestion.vue?vue&type=template&id=5b2ea616&scoped=true&"
import script from "./SingleSelectQuestion.vue?vue&type=script&lang=js&"
export * from "./SingleSelectQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SingleSelectQuestion.vue?vue&type=style&index=0&id=5b2ea616&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2ea616",
  null
  
)

export default component.exports